<template>
  <v-app>
    <transition name="scroll-y-transition" mode="out-in">
      <router-view :key="$route.fullPath" />
    </transition>
  </v-app>
</template>

<script>
export default {
  name: 'App'
}
</script>
